<template>
  <BaseModal
    :heading="$t('reports.totals.pos_tips')"
    small
    @close="$emit('close')"
    v-test="'pos-payments-tips-modal'"
  >
    <div :class="$style.header">
      <DateSelect
        v-bind="{ startDate, endDate }"
        :label="$t('global.actions.period')"
        @select="onDateSelect"
      />
    </div>
    <div v-if="firstFetchFinished && posPayments.length === 0">
      {{ $t('global.no_results') }}
    </div>
    <BaseTable
      v-else
      :headers="[
        $t('global.employee'),
        $t('global.date'),
        $t('reports.totals.tip_amount')
      ]"
      :rows="
        posPayments.map((posPayment) => ({
          id: posPayment.id,
          cells: [
            posPayment.employees.map((employee) => employee.name).join(', '),
            filters.dateTime(posPayment.createdAt),
            filters.currency(posPayment.tipAmount)
          ],
          actions: ['pdf']
        }))
      "
      @action="showPdf"
      v-test="'pos-payments-table'"
    />
    <LoadMore
      v-show="firstFetchFinished && !allDataFetched"
      @shown="fetchMore"
    />
  </BaseModal>
</template>

<script setup lang="ts">
import gql from 'graphql-tag';
import { usePagination } from '@/apollo/pagination';
import filters from '@/filters';
import LoadMore from '@/components/LoadMore.vue';
import config from '@/config';
import DateSelect from '../components/DateSelect.vue';

const props = defineProps<{
  startDate: string;
  endDate: string;
}>();

defineEmits(['close']);

const {
  posPayments,
  firstFetchFinished,
  allDataFetched,
  variables,
  fetchMore,
} = usePagination({
  fieldName: 'posPayments',
  query: gql`
    query getPosPayments(
      $startDate: DateTime
      $endDate: DateTime
      $onlyTips: Boolean
    ) {
      posPayments(
        startDate: $startDate
        endDate: $endDate
        onlyTips: $onlyTips
      ) {
        id
        amount
        tipAmount
        createdAt
        employees {
          id
          name
        }
      }
    }
  `,
  variables: {
    startDate: props.startDate,
    endDate: props.endDate,
    onlyTips: true,
  },
});

const showPdf = ({ id }: { id: string }) => {
  window.open(`${config.backendUrl}/orders/${id}.pdf`);
};

const onDateSelect = ({ startDate, endDate }: { startDate: string; endDate: string }) => {
  variables.startDate = startDate;
  variables.endDate = endDate;
};
</script>

<style lang="scss" module>
.header {
  display: flex;
  flex-wrap: wrap;
  gap: $spacing;
  margin-bottom: $spacing;
}
</style> 